import React from "react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import { useI18n } from "../i18n";
import { SERVICES, IMAGES } from "../mock";
import { Truck, ShieldCheck, Wrench, Handshake } from "lucide-react";

const ICONS = { Truck, ShieldCheck, Wrench, Handshake };

export default function Services() {
  const { t } = useI18n();
  return (
    <>
      <SEO title={{ es: "Servicios", en: "Services" }} path="/servicios" description={{ es: "Logística, cumplimiento, servicio técnico en sitio y contratos marco.", en: "Logistics, compliance, on-site technical service and framework contracts." }} />
      <section className="hero phero">
        <div className="bg" style={{ backgroundImage: `url(${IMAGES.workers})` }} />
        <div className="shade" />
        <div className="container-x inner">
          <Breadcrumbs items={[{ label: { es: "Inicio", en: "Home" }, href: "/" }, { label: { es: "Servicios", en: "Services" } }]} />
          <span className="eyebrow">{t({ es: "Servicios", en: "Services" })}</span>
          <h1>{t({ es: "Un servicio integral, del pedido a la puesta en marcha", en: "End-to-end service, from order to commissioning" })}</h1>
        </div>
      </section>
      <section className="section">
        <div className="container-x">
          <div className="grid-2">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon];
              return (
                <Reveal key={i} delay={i * 80}>
                  <div className="card" style={{ padding: 30, display: "flex", gap: 20 }}>
                    <div style={{ width: 60, height: 60, borderRadius: 10, background: "var(--navy)", display: "grid", placeItems: "center", color: "var(--gold)", flexShrink: 0 }}><Icon size={28} /></div>
                    <div>
                      <h3 style={{ marginTop: 0, fontSize: 24 }}>{t(s.title)}</h3>
                      <p style={{ margin: 0, color: "#475066", fontSize: 15, lineHeight: 1.7 }}>{t(s.desc)}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
